export interface IAppConfigurationStore {
  configurationsList: IAppConfig[];
  selectedConfiguration: IAppConfig;
  loading: boolean;
  getAppConfigurations(): Promise<any>;
  getConfigById(key: string): Promise<any>;
  updateConfig(updatedConfig: UpdateAppConfigRequest, key: string): Promise<any>;
}

export interface IAppConfig {
  key: string;
  value: string;
  edit?: string;
}

export interface UpdateAppConfigRequest {
  value: string;
}

export const emptyConfig: IAppConfig = {
  key: '',
  value: '',
};
